import { useEffect, useState, useLayoutEffect } from 'react'
import { useOutletContext, useParams } from 'react-router'
import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { layoutStore } from 'shared/layout'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { openConversationByParams } from 'features/OpenConversation/openConversation'
import { ConversationMessages } from 'widgets/ConversationMessages'
import { ConversationList } from 'pages/conversations/ui/ConversationList'
import { ConversationsListSyncTools } from 'pages/conversations/ui/webmcp/ConversationsListSyncTools'
import {
  ProviderConversationsPage,
  useConversationsPageContext,
} from 'pages/conversations/context/conversationsPageContext'
import { ConversationsPageStore } from 'pages/conversations/store/conversationsPageStore'
import { useConversationsPageLayoutContext } from 'pages/conversations/context/conversationsPageLayoutContext'
import { type ConversationsTemplateContextType } from 'pages/conversations/layout/ConversationsTemplateLayout/conversationsTemplateLayout'

export const ConversationsPageContent = observer(() => {
  const { conversationId } = useParams()
  const { onOpenSearch } = useConversationsPageLayoutContext()
  const store = useConversationsPageContext()
  const entities = useEntitiesContext()
  const conversationStore = store.entities.conversationStore
  const conversation = conversationStore.currentItem
  const { setList } = useOutletContext<ConversationsTemplateContextType>()
  const contact_ids = uiStore.searchParams?.getAll('contact_id')?.map((id) => Number(id))
  const inbox_id = uiStore.searchParams?.get('inbox_id')
  const query = uiStore.searchParams?.get('query')
  const isNotConversationId = ['null', undefined].includes(conversationId)
  const shouldModeNotOpen = !!layoutStore.isMobileView && isNotConversationId

  useEffect(() => {
    store.emitOpenConversationSignal()
    setList(<ConversationList store={store.conversationListStore} />)

    if (contact_ids && inbox_id) {
      openConversationByParams(entities)(Number(inbox_id), contact_ids).then(() => {
        store.emitOpenConversationSignal()
      })
    }
    if (query) {
      onOpenSearch(query)
    }

    return () => {
      store.reset()
    }
  }, [])

  useEffect(() => {
    if (conversation) {
      entities.contactsStore.getById(conversation.contact_id, true)
    }
  }, [conversation])

  useLayoutEffect(() => {
    conversationStore.setModeNotOpen(shouldModeNotOpen)

    return () => {
      conversationStore.setCurrentItemId(null)
    }
  }, [shouldModeNotOpen])

  useLayoutEffect(() => {
    const id = isNotConversationId ? null : Number(conversationId)

    if (!layoutStore.isMobileView) {
      conversationStore.setCurrentItemId(id)
    }
  }, [conversationId])

  return (
    <>
      <ConversationMessages store={store.conversationMessagesStore} />
      <ConversationsListSyncTools />
    </>
  )
})

export const ConversationsPage = () => {
  const pageLayoutStore = useConversationsPageLayoutContext()
  const entities = useEntitiesContext()
  const [store] = useState(
    () =>
      new ConversationsPageStore(
        pageLayoutStore.pageLayoutStore,
        pageLayoutStore.callModalStore,
        pageLayoutStore.conversationMenuStore,
        pageLayoutStore.conversationSearchStore,
        pageLayoutStore.contactsDetailsManageStore,
        pageLayoutStore.contactCreateModalStore,
        entities
      )
  )

  return (
    <ProviderConversationsPage value={store}>
      <ConversationsPageContent />
    </ProviderConversationsPage>
  )
}
